import React from "react";

const Footer = () => {
    return (
        <>
            <div className="foot_style">
                <h1 className="made_with">@2022 Shruti Yadav. All Rights Reserved</h1>
            </div>
        </>
    );
}

export default Footer;